//
//
//
//
//
//
import OrderInput from './../../components/order/input/Input';
export default {
  name: "Orders.vue",
  components: {
    OrderInput: OrderInput
  }
};